import React, { FC } from 'react';
import BottomSheet from '@/components/BottomSheet';
import { FormsProvider } from '@/components/HookForm';
import useRestoreForm from './components/RestoreForm/useRestoreForm';

interface ICardRestoreStep {
  refetchCardStatus: () => void;
}
const CardRestoreStep: FC<ICardRestoreStep> = ({ refetchCardStatus }) => (
  <FormsProvider
    forms={[useRestoreForm()]}
    onComplete={async () => {
      await refetchCardStatus();
      BottomSheet.close();
    }}
  />
);
export default CardRestoreStep;
